<script lang="ts">
	import type { ConfigsEntity } from '$lib/api/restApi';
	import { onMount } from 'svelte';

	export let configs: ConfigsEntity[];

	const facebookInit = configs
		.map((config) => `fbq('init', '${config.values?.tracking_id || ''}');`)
		.join(';');

	onMount(() => {
		// Hack to get the script to run after mount
		let facebookPixel = document.getElementById('facebookPixel');
		if (facebookPixel) {
			facebookPixel.innerText = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
			${facebookInit};
			fbq('track', 'PageView');`;
		}
	});
</script>

<svelte:head>
	<script id="facebookPixel"></script>
</svelte:head>
<noscript>
	{#each configs as config}
		<!-- svelte-ignore a11y-missing-attribute -->
		<img
			height="1"
			width="1"
			style="display:none"
			src="https://www.facebook.com/tr?id={config.values?.tracking_id}&ev=PageView&noscript=1" />
	{/each}
</noscript>
